export function capitalize(word) {
  if (!word) {
    return ''
  }

  return `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`
}

export function titleize(sentence) {
  if (!sentence) {
    return ''
  }
  const stripped = sentence.replace(/_/, ' ')
  let stringArray = stripped.split(' ')
  stringArray = stringArray.map((string) => {
    return capitalize(string)
  })
  return stringArray.join(' ')
}
